import { MediaGallery } from './gallery/MediaGallery';
import { MediaFileField } from './MediaFileField';

// Register the custom element if not already defined
if (!customElements.get('media-picker')) {
  customElements.define('media-picker', MediaFileField);
}

if (!customElements.get('media-file-list')) {
  customElements.define('media-file-list', MediaGallery);
}
